// src/pages/fiscal/mdfe/SeguradoraCad.js
import React from 'react';
import { Seguradora } from '../../../models/fiscal/Seguradora';
import CadastroFiscalCad from './CadastroFiscalCad';

const campos = [
  { nome: 'nome', label: 'Nome', size: 300 },
  { nome: 'cnpj', label: 'CNPJ', size: 180, mask: '99.999.999/9999-99' },
  { nome: 'ativo', label: 'Ativo', tipo: 'check' },
];
const SeguradoraCad = (props) => <CadastroFiscalCad {...props} tipo="seguradoras" titulo="Seguradora" Model={Seguradora} campos={campos} />;
export default SeguradoraCad;
